// Split out of EvalResultsHero.tsx (react-refresh/only-export-components) —
// a pure string helper, not a component. Behavior unchanged.

/**
 * Strip a score-restating LEAD sentence from the coaching summary.
 *
 * The LLM summary often opens with "Your overall score is 89.6 out of 100."
 * Next to the giant hero numeral that sentence is redundant — and worse, it
 * shows the unrounded value (89.6) beside the rounded numeral (90), which reads
 * as a contradiction (owner fidelity review 2026-08-01). The prototype verdict
 * is a short coaching statement; drop the score restatement and lead with the
 * substance. If stripping would leave nothing, keep the original.
 */
export function stripScoreRestatement(headline: string): string {
  const stripped = headline
    .replace(/^\s*your\s+overall\s+score\s+is\s+[\d.]+\s*(?:out\s+of\s+100|\/\s*100)?[.!]?\s*/i, '')
    .trim();
  return stripped.length > 0 ? stripped : headline;
}
